/**
 * Setelah user memperkenalkan nama: satu baris ajakan menu (pilihan lewat tombol di bawah). sponsorLine = "Anda direferensikan…" atau kosong.
 *
 * Materi integrasi klien:
 * - Produk: landing Gelang, Minicon, JPB AORA (+ disclaimer tidak ke WA)
 * - Peluang Bisnis: video manfaat mitra JPB + rekaman Aktivasi Intuisi (Drive)
 *
 * Masih menunggu materi final terpisah (bila ada):
 * - Testimoni kutipan resmi (gelang & topi, minicon, workshop)
 */
export function buildOpeningHubText(sponsorLine) {
  const sponsorBlock =
    sponsorLine && sponsorLine.trim() !== ''
      ? `${sponsorLine}\n\n`
      : '';
  return (
    `Saya siap membantu Anda mendapatkan informasi seputar **produk**, **peluang bisnis**, **kelas**, dan **dukungan member** JP Buana.\n\n` +
    sponsorBlock +
    `**Silakan pilih kebutuhan Anda.**`
  );
}

export const TENTANG_SUBMENU_BOT_INTRO =
  'JP Buana adalah platform yang menggabungkan produk, pengembangan diri, dan peluang bisnis dalam satu ekosistem yang terintegrasi.\n\n' +
  '**Silakan pilih topik**, atau **Menu Utama** untuk kembali.';

export function buildTentangSubItems() {
  /** Satu array objek final — afterResponseQuickItems harus merujuk ke array ini, bukan ke salinan “sebelum map”. */
  const items = [
    { text: 'Profil JP Buana', icon: '🏢', type: 'richContent', contentKey: 'profil' },
    { text: 'Visi & Misi', icon: '🎯', type: 'richContent', contentKey: 'visiMisi' },
    { text: 'Kisah Founder', icon: '📖', type: 'richContent', contentKey: 'founder' },
    { text: 'Keunggulan Sistem JP Buana', icon: '⚡', type: 'richContent', contentKey: 'keunggulan' },
  ];
  items.forEach((entry) => {
    entry.afterResponseQuickItems = items;
  });
  return items;
}

/**
 * @param {Array} productsList
 * @param {string} sponsorFromUrl
 */
export function buildMenuItems(productsList, sponsorFromUrl) {
  const sponsor = sponsorFromUrl || 'demoaccount';
  const tentangSubItems = buildTentangSubItems();

  return [
    {
      text: 'Tentang JP Buana',
      icon: '⭐',
      submenuBotIntro: TENTANG_SUBMENU_BOT_INTRO,
      subItems: tentangSubItems,
    },
    {
      text: 'Produk JP Buana',
      icon: '📦',
      type: 'richContent',
      contentKey: 'produk',
      sponsorForPanel: sponsor,
    },
    { text: 'Peluang Bisnis', icon: '💼', type: 'richContent', contentKey: 'peluang' },
    // TODO(client-final): Panel `workshop` — URL landing + copy; halaman tidak terhubung ke WA (sub-website produk)
    { text: 'Workshop', icon: '🎓', type: 'richContent', contentKey: 'workshop' },
    { text: 'Mentoring Mingguan', icon: '🤝', type: 'richContent', contentKey: 'mentoring' },
    // TODO(client-final): Panel `testimoni` — 3 kutipan resmi (gelang & topi, minicon, workshop).
    { text: 'Testimoni', icon: '💬', type: 'richContent', contentKey: 'testimoni' },
    { text: 'Jadwal Zoom', icon: '📅', type: 'richContent', contentKey: 'jadwal' },
    { text: 'Hubungi Admin', icon: '📞', type: 'richContent', contentKey: 'kontak' },
    {
      text: 'Video Inspirasi',
      icon: '▶️',
      submenuBotIntro: '**Video inspirasi JP Buana** — silakan pilih:',
      subItems: [
        {
          text: 'Energi: Gagal makin gagal, sukses makin sukses',
          icon: '▶️',
          type: 'video',
          videoUrl: 'https://youtube.com/shorts/pUxuyDQU6YM',
        },
        { text: 'AKU DAN PERUBAHAN', icon: '▶️', type: 'video', videoUrl: 'https://www.youtube.com/watch?v=raKfwP0liwQ' },
        {
          text: 'UCAPKAN MANTRA INI DAN JADI DIRMU SENDIRI',
          icon: '▶️',
          type: 'video',
          videoUrl: 'https://www.youtube.com/watch?v=9zW-pTKg4lk',
        },
      ],
    },
  ];
}
